import script from "./detail-cancel.vue?vue&type=script&lang=ts&setup=true"
export * from "./detail-cancel.vue?vue&type=script&lang=ts&setup=true"

import "./detail-cancel.vue?vue&type=style&index=0&id=a3b0e6bc&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3b0e6bc"]])

export default __exports__